import React from 'react'

const TimelineCard = ({ timelineItem, isActive, onClick }) => {
  return (
    <div 
      className={`glass-card rounded-2xl p-6 cursor-pointer transition-all duration-500 hover:scale-105 group relative overflow-hidden focus-within:ring-2 focus-within:ring-white/50 ${
        isActive ? 'ring-2 ring-white/30 scale-105' : ''
      }`}
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault()
          onClick()
        }
      }}
      aria-label={`View details for ${timelineItem.title} era (${timelineItem.year})`}
      aria-pressed={isActive}
    >
      {/* Background Gradient */}
      <div className={`absolute inset-0 bg-gradient-to-br ${timelineItem.color} opacity-10 group-hover:opacity-20 transition-opacity duration-300`}></div>
      
      {/* Content */}
      <div className="relative z-10">
        {/* Header */}
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center space-x-3">
            <div className={`w-3 h-3 bg-gradient-to-r ${timelineItem.color} rounded-full animate-pulse`}></div>
            <span className="text-white/80 font-mono text-sm">{timelineItem.year}</span>
          </div>
          <div className={`p-2 rounded-lg bg-gradient-to-r ${timelineItem.color} bg-opacity-20`}>
            <svg className="w-4 h-4 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
            </svg>
          </div>
        </div>

        {/* Title */}
        <h3 className="text-xl font-bold text-white mb-2 group-hover:text-blue-200 transition-colors">
          {timelineItem.title}
        </h3>
        <p className="text-white/70 text-sm mb-4">{timelineItem.subtitle}</p>

        {/* Description */}
        <p className="text-white/80 text-sm mb-4 line-clamp-3">
          {timelineItem.description}
        </p>

        {/* Key Technologies */}
        <div className="flex flex-wrap gap-2 mb-4">
          {timelineItem.technologies.slice(0, 3).map((tech, index) => (
            <span
              key={index}
              className={`px-2 py-1 bg-gradient-to-r ${timelineItem.color} bg-opacity-20 text-white/90 text-xs rounded-md border border-white/20`}
            >
              {tech}
            </span>
          ))}
          {timelineItem.technologies.length > 3 && (
            <span className="px-2 py-1 bg-white/10 text-white/70 text-xs rounded-md">
              +{timelineItem.technologies.length - 3}
            </span>
          )}
        </div>

        {/* Key Events Count */}
        <div className="flex items-center justify-between text-white/60 text-xs">
          <span>{timelineItem.keyEvents.length} key events</span>
          <svg className="w-4 h-4 group-hover:translate-x-1 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
        </div>
      </div>

      {/* Hover Effect */}
      <div className={`absolute inset-0 bg-gradient-to-r ${timelineItem.color} opacity-0 group-hover:opacity-5 transition-opacity duration-300 pointer-events-none rounded-2xl`}></div>
    </div>
  )
}

export default TimelineCard
